// extracted by mini-css-extract-plugin
export default {"globalToast":"caba490f0e3f","globalToastContent":"c9dd7c7c7444"};